<!-- 账户信息 -->
<template>
    <div class="content">
        <div class="account">
            <h3><span>修改登录密码</span></h3>
            <div class="account-info">
                <el-form label-position="top" label-width="80px">
                    <el-form-item label="登录账号">
                        <!-- <el-input v-model="userInfo.Account" readonly disabled></el-input> -->
                    </el-form-item>
                    <el-form-item label="原密码" label-suffix="sdfsdfsdf">
                        <el-input v-model="formInfo.OldPassword" placeholder="密码设置为字母加数字 8-12位" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="新密码">
                        <el-input v-model="formInfo.NewPassword" placeholder="密码设置为字母加数字 8-12位" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="新密码确认">
                        <el-input v-model="formInfo.NewPassword1" placeholder="密码设置为字母加数字 8-12位" show-password></el-input>
                    </el-form-item>
                </el-form>
                <el-row>
                    <el-col :span="24" :offset="12">
                        <el-button type="primary" icon="el-icon-edit" @click="submitForm">修改密码</el-button>
                    </el-col>
                </el-row>
                <el-upload class="upload-demo" action="" :on-change="handleChange" :on-exceed="handleExceed"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    :auto-upload="false">
                    <!-- 只 能 上 传 xlsx / xls 文 件 -->
                    <el-button size="small" type="primary">点击上传1</el-button>
                </el-upload>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
//import md5 from 'js-md5'
import olmap from '../encoder/test/olmap.vue'
import xlsx from 'xlsx'
export default {
    components: { olmap },
    name: 'password',
    data() {
        return {
            formInfo: {
                OldPassword: '',
                NewPassword: '',
                NewPassword1: ''
            }
        }
    },
    computed: {
        ...mapState(['userInfo'])
    },
    mounted() {
        this.initData()
    },
    methods: {
        handleExceed() {

        },
        getpHDegree(val) {
            if (val < 5.5) {
                return 1;
            }
            if (5.5 <= val && val < 5.8) {
                return 2;
            }
            if (5.8 <= val && val < 6.0) {
                return 3;
            }
            if (6.0 <= val && val < 6.5) {
                return 4;
            }
            if (6.5 <= val && val < 7.0) {
                return 5;
            }
            if (7.0 <= val && val < 7.5) {
                return 6;
            }
            if (7.5 <= val && val < 7.8) {
                return 7;
            }
            if (7.8 <= val && val < 8.0) {
                return 8;
            }
            if (8.0 <= val && val < 8.5) {
                return 9;
            }
            if (8.5 <= val) {
                return 10;
            }
            return 10;
        },
        handleChange(file, fileList) {
            const fileTemp = file.raw;
            if (fileTemp) {
                if ((fileTemp.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                    || (fileTemp.type == 'application/vnd.ms-excel')) {
                    this.handleExcel(fileTemp);
                } else {
                    console.log("文件格式错误，请删除后重新上传")
                    // this.$message({
                    //     type: 'warning',
                    //     message: '文件格式错误，请删除后重新上传！'
                    // })
                }
            } else {
                this.$message({
                    type: 'warning',
                    message: '请上文件！'
                })
            }
        },
        handleExcel(fileTemp) {
            let _this = this;
            const file = fileTemp;
            var rABS = false; //是否将文件读取为二进制字符串
            var f = file;
            var reader = new FileReader();
            FileReader.prototype.readAsBinaryString = function (f) {
                var binary = "";
                var rABS = false; //是否将文件读取为二进制字符串
                var wb; //读取完成的数据
                var outdata;
                var reader = new FileReader();
                reader.onload = function (e) {
                    var bytes = new Uint8Array(reader.result);
                    var length = bytes.byteLength;
                    for (var i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    var XLSX = require("xlsx");
                    if (rABS) {
                        wb = XLSX.read(btoa(fixdata(binary)), {
                            //手动转化
                            type: "base64"
                        });
                    } else {
                        wb = XLSX.read(binary, {
                            type: "binary"
                        });
                    }
                    outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); //outdata就是你想要的东西
                    console.log('未处理的原始数据如下：');
                    console.log(outdata);
                    //此处可对数据进行处理
                    let arr = [];

                    outdata.map((v, index) => {//0-20
                        console.log("xxx", Math.random() / 100000)
                        if (true) {
                            let obj = {
                                type: "Feature",
                                "properties": {
                                    "ph": _this.getpHDegree(v.ph),

                                    "totalN": v.alln,
                                    "totalP": v.allp,
                                    "totalK": v.allk,
                                    "orangic": v.orangic

                                },
                                "geometry": {
                                    "type": "Point",
                                    "coordinates": [v.lan, v.lat]
                                }

                            }
                            // let obj = {
                            //     x: parseFloat((v.lan + Math.random()).toFixed(12)),
                            //     y: parseFloat((v.lat + Math.random()).toFixed(12)),
                            //     // z: Math.random() * 10// parseFloat(v.alln)
                            //     z: _this.getpHDegree(v.ph)
                            // }
                            arr.push(obj)
                        }

                    });
                    const geoJson = {

                        "type": "FeatureCollection",
                        "features": arr
                    }
                    console.log(JSON.stringify(geoJson))
                    // _this.da = arr;
                    // _this.dalen = arr.length;
                    return arr;
                };
                reader.readAsArrayBuffer(f);
            };
            if (rABS) {
                reader.readAsArrayBuffer(f);
            } else {
                reader.readAsBinaryString(f);
            }
        },

        upload(file, fileList) {
            console.log("file=", file)
            const files = { 0: file.raw }// 取到File
            console.log("files=", files)
            //  this.readExcel(files)

            // 获取文件名称
            //let name = files.name

            // 获取文件后缀
            //let suffix = name.substr(name.lastIndexOf("."))
            let reader = new FileReader()
            reader.onload = (event) => {
                try {
                    let { result } = event.target;
                    console.log("result==", result)
                    // 读取文件
                    // let workbook = XLSX.read(result, { type: 'binary', cellDates: true })
                    // let data = []
                    // let col = []
                    // let colx = ['序号', 'PH', '温度(℃)', '溶解氧(mg/L)', '透明度(cm)', '监测时间']
                    // // 循环文件中的每个表
                    // for (let sheet in workbook.Sheets) {
                    //     if (workbook.Sheets.hasOwnProperty(sheet)) {
                    //         // 将获取到表中的数据转化为json格式
                    //         data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]))
                    //         col = col.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet], { header: 1, defval: '', blankrows: true }))
                    //     }
                    // }
                    // for (let index = 1; index < colx.length; index++) {
                    //     if (col[0].indexOf(colx[index]) == -1) {
                    //         message.error(`模块缺少${colx[index]}属性`)
                    //         setFileName("")
                    //         setIsLoading(false)
                    //         return
                    //     }
                    // }
                } catch (e) {

                }
            }
            reader.readAsBinaryString(files)
            setIsLoading(true)
        },
        readExcel(files) { // 表格导入
            if (files.length <= 0) { // 如果没有文件名
                return false
            } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
                this.$Message.error('上传格式不正确，请上传xls或者xlsx格式')
                return false
            }

            const fileReader = new FileReader()
            fileReader.onload = (files) => {
                try {
                    const data = files.target.result
                    const workbook = xlsx.read(data, {
                        type: 'binary'
                    })
                    const wsname = workbook.SheetNames[0]// 取第一张表
                    const ws = xlsx.utils.sheet_to_json(workbook.Sheets[wsname])// 生成json表格内容
                    console.log(ws, 'ws是表格里的数据，且是json格式')
                    this.menuData = ws
                    // 重写数据
                    this.$refs.upload.value = ''
                    // return ws
                } catch (e) {
                    console.log(e)
                    return false
                }
            }
            fileReader.readAsBinaryString(files[0])
        },
        initData() {
            setTimeout(() => {
                console.log("xlsx11==", xlsx)
            }, 1000)

            //2022 7.4  ph 7.61; DO 8.53;COD 52.59;高锰酸钾 8.22；氨氮 2.40；TN 4.20;TP 0.35;
            // 2023 7.1 ph 7.00; DO 8.60;COD 73.92;高锰酸钾 3.47；氨氮 0.25；TN 5.42;TP 0.62
            //2023 8.3  PH 6.95; DO 7.94;COD 82.75;高锰酸钾 1.69；氨氮 0.38; TN 1.94;TP 0.37
            //2023 8.4  PH 6.76; DO 7.72;COD 72.5; 高锰酸钾 1.89; 氨氮 0.04；TN 6.98;TP 0.53
            const list = [0.24,
                0.41,
                0.39,
                0.41,
                1.04,
                0.31,
                0.25,
                1.18,
                1.14,
                0.14,
                0.57,
                0.25,


















            ];
            const total = list.reduce((pre, cur) => {
                return pre + cur;
            }, 0).toFixed(2)
            console.log("total==", total / list.length.toFixed(2))
        },
        submitForm() {
            if (this.NewPassword !== this.NewPassword1) {
                this.$message.error('两次输入的密码不一致')
                return
            }
            this.$request('user', 'submitpwd', {
                // OldPassword: md5(this.formInfo.OldPassword),
                // NewPassword: md5(this.formInfo.NewPassword)
            }).then(res => {
                if (res.code === 1) {
                    this.$alert('您的密码修改成功，请重新登录', '登录', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.$store.commit('logout')
                            this.$router.push({ name: 'login' })
                        }
                    })
                } else {
                    this.$message.error(res.msg)
                }
            })
        }
    }
}
</script>
<style lang='less' scoped>
.content {
    position: relative;
    left: 165px;
    top: 90px;
    width: calc(100vw - 175px);
    height: calc(100vh - 90px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 30px;
}

.account {
    background-color: #fff;
    padding: 30px;
    border-radius: 10px;
    text-align: left;

    h3 {
        padding-bottom: 25px;
        border-bottom: solid 1px #ededed;

        span {
            color: #090e15;
            font-size: 20px;
            letter-spacing: 2px;
            font-weight: bold;
            display: block;
            line-height: 28px;
            background: url(../../assets/category/te-6.png) no-repeat left center;
            padding-left: 40px;
        }
    }
}
</style>
